import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES: Record<string, string> = {
    '/': 'Phoenix Égalité des Chances | Accueil',
    '/projets': 'Nos Projets de Tutorat | Phoenix',
    '/carte-des-projets': 'Carte des Projets | Phoenix',
    '/evenements': 'Nos Événements | Phoenix',
    '/partenaires': 'Nos Partenaires | Phoenix',
    '/documents': 'Documents & Fiches | Phoenix',
    '/mentions-legales': 'Mentions Légales | Phoenix',
    '/transparence': 'Transparence & Rapports | Phoenix',
    '/contact': 'Contact & Recrutement | Phoenix',
    '/planning': 'Tableau de bord | Phoenix Planning',
    '/planning/login': 'Connexion | Phoenix Planning',
    '/planning/disponibilites': 'Mes Disponibilités | Phoenix Planning',
    '/planning/horaire': 'Mon Horaire | Phoenix Planning',
    '/planning/compte': 'Mon Compte | Phoenix Planning',
    '/planning/validation': 'Validation Présences | Phoenix Planning',
    '/planning/recap': 'Récapitulatif des Heures | Phoenix Planning',
    '/planning/events': 'Validation Événements | Phoenix Planning',
    '/planning/mes-evenements': 'Mes Événements | Phoenix Planning',
    '/planning/notifications': 'Notifications | Phoenix Planning',
};

export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Force instant scroll reset on route change
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // On gère uniquement les titres pour l'intranet /planning (les pages publiques utilisent le composant <SEO>)
        if (pathname.startsWith('/planning')) {
            document.title = PAGE_TITLES[pathname] || 'Phoenix Planning';
        }
    }, [pathname]);

    return null;
}
